module.exports = __webpack_public_path__ + "img/info-icon-small.0daea487.svg";